import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import lib from '../../../helpers/lib';
import Skeleton from 'react-loading-skeleton';
import '../styles.scss';

export default function AnaliticoMixClientePrecoMedio(dados) {
  return (
    <div>
      <div className="table-responsive table-historico mt-4" onCopy={(e) => lib.parseCopiedText(e)}>
        {!dados?.isLoading && dados?.faturamentoClientesPrecosMedios?.length > 0 ? (
          ([...dados?.faturamentoClientesPrecosMedios] || [])?.map((vendedor, index) => (
            <div className="vendedor" key={index}>
              <p className="mb-3 fw-600" style={{ fontSize: '1.3em' }}>
                {vendedor.vendedorNome}
              </p>

              <Table striped bordered hover width="100%" className="table-relatorio">
                <thead>
                  <tr>
                    {/* <th>#</th> */}
                    <th>Cliente</th>
                    <th>Produto</th>
                    <th>
                      {lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado - 2)?.label}
                    </th>
                    <th>
                      {lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado - 1)?.label}
                    </th>
                    <th>{lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado)?.label}</th>
                    <th>Total</th>
                  </tr>
                </thead>
                {vendedor?.clientes?.length > 0 ? (
                  ([...vendedor?.clientes] || [])?.map((cliente, indexCliente) => (
                    <tbody className="table-sem-totalizadores" key={indexCliente}>
                      <tr className="fw-600">
                        {/* <td></td> */}
                        <td>{cliente.clienteNome}</td>
                        <td>CNPJ: {cliente.clienteCnpj}</td>
                        <td>
                          {cliente.precoMedioMesAntepenultimo?.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                          })}
                        </td>
                        <td>
                          {cliente.precoMedioMesAnterior?.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                          })}
                        </td>
                        <td>
                          {cliente.precoMedioMesAtual?.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                          })}
                        </td>
                        <td>
                          {cliente.precoMedioTotalTrimestre?.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                          })}
                        </td>
                      </tr>

                      {cliente?.produtos?.map((produto, produtoIndex) => (
                        <tr key={produtoIndex}>
                          {/* <td>{produtoIndex + 1}</td> */}
                          <td></td>
                          <td>{produto.produtoNome}</td>
                          <td>
                            {produto.precoMedioMesAntepenultimo?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </td>
                          <td>
                            {produto.precoMedioMesAnterior?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </td>
                          <td>
                            {produto.precoMedioMesAtual?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </td>
                          <td>
                            {produto.precoMedioTotalTrimestre?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </Table>

              {index + 1 < dados?.faturamentoClientesPrecosMedios?.length ? (
                <hr className="my-5" />
              ) : null}
            </div>
          ))
        ) : (
          <Skeleton count={10} />
        )}
      </div>
    </div>
    // </Layout>
  );
}
